<template>
  <header id="header" class="fixed-top">

    <div class="container">

      <nav class="navbar navbar-expand-lg fixed-top navbar-light bg-light ">
        <div class="container">

          <div class="d-flex justify-content-start p-2 flex-fill" data-aos="fade-right" data-aos-delay="150">
            <a href="/">
              <img src="../assets/img/logo.png" alt="" class="img-fluid" style="width: 180px; margin-left: -7px;">
            </a>
          </div>

          <div class="d-flex justify-content-end p-2 flex-fill">
            <button class="navbar-toggler-menu" type="button" data-bs-toggle="collapse" data-bs-target="#navbarMenu"
              aria-controls="navbarMenu" aria-expanded="false" aria-label="Toggle navigation">
              <span class="navbar-toggler-icon"></span>
            </button>
          </div>

          <div id="navbarMenu" class="collapse navbar-collapse p-2 flex-fill justify-content-end">
            <div class="navbar-nav d-flex align-items-start">
              <a class="nav-link" href="#planos" @click="navegarSecao('planos')">Planos</a>
              <a class="nav-link" href="#servicos" @click="navegarSecao('servicos')">Serviços</a>
              <a class="nav-link" href="https://api.whatsapp.com/send/?phone=5544999329925&amp;text=Acessei%20o%20site%20do%20Sigame%20e%20gostaria%20de%20ser%20atendido."
                target="_blank">Atendimento
              </a>
              <a class="nav-link" href="#sobre" @click="navegarSecao('sobre-nos')">Sobre nós</a>
            </div>
            <!--
            <div class="navbar-nav d-flex align-items-center">
              <a class="btn-default"
                href="https://app.sigame.digital/auth">Entrar
              </a>
            </div>
            -->
          </div>

        </div>
      </nav>
    </div>
  </header>

</template>

<script>
export default {
  name: 'HeaderComp',

  methods: {
    pegarCaminhoRaizSite () {
      return window.location.origin + '/'
    },

    navegarSecao (sectionId) {
      const navbarHeight = document.querySelector('.navbar').offsetHeight
      const section = document.querySelector(`#${sectionId}`)
      console.log('section.offsetTop = ' + section.offsetTop)
      const sectionTop = section.offsetTop - navbarHeight
      let isMobile = false

      window.scrollTo({
        top: sectionTop,
        behavior: 'smooth',
        block: 'start'
      })

      // Fechar a navBar após o clique no link âncora
      const navbarToggler = document.querySelector('.navbar-toggler-menu')
      const navbarCollapse = document.querySelector('.navbar-collapse')
      if (navbarToggler && navbarCollapse.classList.contains('show')) {
        isMobile = true
        navbarToggler.click()
      }

      if (isMobile) {
        isMobile = false
        setTimeout(() => {
          window.scrollTo({
            top: sectionTop + 250,
            behavior: 'smooth',
            block: 'start'
          })
        }, 100)
      } else {
        setTimeout(() => {
          window.scrollTo({
            top: sectionTop - 2,
            behavior: 'smooth',
            block: 'start'
          })
        }, 100)
      }
    }
    /*
    navegarSecao (sectionId) {
      const section = document.querySelector(`#${sectionId}`)
      if (section) {
        section.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        })
      }
    },
    */
  }
}
</script>

<style scoped lang="scss">

#header {
  z-index: 997;
  transition: all 0.5s;
  padding: 22px 0;
  background: $bg-base;
}
.navbar {
  background: $bg-base;
  box-shadow: $box-shadow-navbar;
}

.navbar-toggler-menu {
  display: none;
}

.nav-link {
  margin-right: 0px;
  margin-left: 25px;
  padding: 0px 12px;
  color: $a-color;
  font-size: 16px;
  font-weight: 400;
  white-space: nowrap;
}

.nav-link:hover {
  color: $a-color-hover;
}

@media (max-width: 991px) {
  .btn-default, .btn-default:focus {
    display: flex;
    align-items: end;
    margin: 20px;
  }

  .navbar-toggler-menu {
    display: inline-block;
    padding: 0.25rem 0.75rem;
    font-size: 1.25rem;
    line-height: 1;
    background-color: transparent;
    border: 2px;
    border-radius: 50%;
    transition: box-shadow 0.15s ease-in-out;
  }

  .nav-link {
    margin-left: 0px;
    padding: 4px;
  }

  .navbar ul {
    display: none;
  }
}
</style>
